import { Fade, Grid } from '@mui/material';

import strings from 'constants/index';

const NotFoundPage = () => (
  <Grid container direction="column" justifyContent="center" alignItems="center">
    <Fade in>
      <h1>{strings.not_found_404}</h1>
    </Fade>
  </Grid>
);

export default NotFoundPage;
